<template>
    <transition name="slide-fade">
        <div class="alert" :class="[transitioning ? 'transition' : '',type]">
            <slot></slot>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            show: Boolean,
            dismiss: Number,
            type: String
        },
        data: function(){
            return {
                transitioning: false
            }
        },
        methods: {
            animate() {
                setTimeout(() => {
                    this.transitioning = true;
                }, this.dismiss - (this.dismiss * 0.1));
                setTimeout(() => {
                    this.$emit('dismissed')
                    this.transitioning = false;
                }, this.dismiss);
            }
        },
        updated: function() {
            if(this.show == true) {
                this.animate()
            }
        }
    };
</script>

<style scoped lang="scss">
    .alert {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        color: white;
        padding: 20px;
        text-align: center;
        font-weight: 700;
        z-index: 99999
    }
    .success {
        background-color: #14ac55;
    }
    .error {
        background-color: #ff5d54;
    }
    .transition {
        opacity: 0;
        transition: opacity 1s linear
    }
</style>
